'use client';

import { useAppSelector } from '../redux/hooks';
import { stripChainFromPath } from './chain-slug';

/**
 * Custom hook to get the breadcrumb data from redux.
 *
 * @param {string} url
 * @returns
 */
export function useGetBreadcrumbData(url: string) {
  const { staticData, dynamicData } = useAppSelector((state) => state.breadcrumbs);
  // Strip chain prefix (e.g. /is, /bs) for matching against static data and patterns
  const strippedUrl = stripChainFromPath(url);

  switch (true) {
    case !url:
      return {};
    case isProductURL(strippedUrl):
      return dynamicData.product || {};
    case isB2BOrderURL(strippedUrl):
      return dynamicData.b2bOrder || {};
    case isB2BOrderConfirmationURL(strippedUrl):
      return dynamicData.b2bOrderConfirmation || {};
    case !!staticData[strippedUrl as keyof typeof staticData]:
      return staticData[strippedUrl as keyof typeof staticData];
    default:
      return {};
  }
}

function isProductURL(url: string) {
  // Define a regular expression pattern to match the product UUID
  const pattern = /^\/taydennystilaukset\/tuotteet\/[A-Za-z0-9_-]+$/;

  // Test if the URL matches the pattern
  return pattern.test(url);
}

function isB2BOrderURL(url: string) {
  // Define a regular expression pattern to match the product UUID
  const pattern = /^\/taydennystilaukset\/tilaushistoria\/[A-Za-z0-9_-]+$/;

  // Test if the URL matches the pattern
  return pattern.test(url);
}

function isB2BOrderConfirmationURL(url: string) {
  // Define a regular expression pattern to match the product UUID
  const pattern = /^\/taydennystilaukset\/ostoskori\/[A-Za-z0-9_-]+$/;

  // Test if the URL matches the pattern
  return pattern.test(url);
}
